import { intcomma } from 'journalize';

export function renderTooltip(data) {
  let candidateRows = [
    {
      name: data.candidate_name_1?.split(' ').at(-1),
      votes: data.candidate_votes_1,
      percent: data.candidate_pct_1,
    },
    {
      name: data.candidate_name_2?.split(' ').at(-1),
      votes: data.candidate_votes_2,
      percent: data.candidate_pct_2,
    },
    {
      name: data.candidate_name_3?.split(' ').at(-1),
      votes: data.candidate_votes_3,
      percent: data.candidate_pct_3,
    },
  ];

  let candidateRowsMarkup = candidateRows
    .map((row) => {
      if (!row.name || row.votes == 0) return ``;

      return `
        <tr>
          <th scope="row" class="text-left">${row.name}</th>
          <td class="text-right">${intcomma(row.votes)}</td>
          <td class="text-right">${Math.round(row.percent * 100)}%</td>
        </tr>
      `;
    })
    .join('');

  let tooltipBodyStart = `<div class="tooltip" aria-live="polite">`;

  let tooltipBody =
    'total_votes' in data && data.total_votes > 10
      ? `
      <h3 class="tooltip-title">Precinct ${data.precinct}</h3>
      <p class="tooltip-subtitle">${
        data.neighborhood ? `A precinct in ${data.neighborhood}` : ''
      }</p>
      <table class="tooltip-table">
      <thead>
        <tr>
          <th scope="col" class="text-left">Candidate</th>
          <th scope="col" class="text-right">Votes</th>
          <th scope="col" class="text-right">Pct.</th>
        </tr>
      </thead>
      <tbody>
        ${candidateRowsMarkup}
      </tbody>
      </table>
      ${
        'total_votes' in data
          ? `<span style="display: block; margin-top: 2px; font-size: 0.9em; opacity: 0.7; padding-left: 4px;">${intcomma(
              data.total_votes
            )} total votes</span>`
          : ''
      }`
      : 'Precincts with fewer than total 10 votes are not shown.';

  let tooltipBodyEnd = `</div>`;

  let t = `
      ${tooltipBodyStart}
      ${tooltipBody}
      ${tooltipBodyEnd}
  `;
  return t;
}
